import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { parseEnumValue } from "web_myplann/Shared/Utils/parseEnumValue";
import type { NavigationPayload } from "web_myplann/Utils/WebViewHandlers/Types/NotificationNavigationTypes";
import { parseNotificationId } from "web_myplann/Utils/WebViewModel";

export type ReminderPushTarget = {
	entityType: ReminderEntityTypeEnum;
	entityId: string;
	reminderId?: number;
};

// The push carries the enum *name* exactly as TimelineReminderDataDTO does
// ("Portfolio", "Property", "IdentificationDocument"); no normalisation here.
export const parseReminderPushTarget = (
	payload: NavigationPayload,
): ReminderPushTarget | null => {
	const entityType = parseEnumValue(ReminderEntityTypeEnum, payload.entityType);
	const entityId = parseNotificationId(payload.entityId);
	if (!entityType || entityId === undefined) {
		return null;
	}
	return {
		entityType,
		entityId: String(entityId),
		reminderId: parseNotificationId(payload.reminderId),
	};
};
